import { Center } from '@chakra-ui/react'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from 'react-use'
import { useRoute } from 'wouter'
import { apiConfig } from '../../common/apiConfig'
import { Container } from '../../common/components/Container'
import { DefaultLoading } from '../../common/components/DefaultLoader'
import { TextLink } from '../../common/components/TextLink'
import { ApplicantProfileApi } from '../../generated'
import { Title } from '../components/Title'
import { signOut } from '../hooks/useApplicant'

type EmailChangeState = 'loading' | 'success' | 'unauthorized' | 'expired' | 'conflict' | 'error'

const EmailChangeComplete: FC = () => {
  const [t] = useTranslation()
  useTitle(t('HU-IAAS メールアドレス変更'))
  const [, params] = useRoute<{ id: string }>('/change-email-requests/:id')
  const token = params?.id
  const [state, setState] = useState<EmailChangeState>(token ? 'loading' : 'error')

  useEffect(() => {
    if (!token) return
    let active = true

    new ApplicantProfileApi(apiConfig)
      .activateChangeEmail(token)
      .then(async () => {
        if (!active) return
        setState('success')
        try {
          await signOut()
        } catch (error) {
          console.log('sign out error', error)
        }
      })
      .catch((error) => {
        if (!active) return
        switch (error.status) {
          case 403:
            setState('unauthorized')
            break
          case 404:
            setState('expired')
            break
          case 409:
            setState('conflict')
            break
          default:
            setState('error')
        }
        console.log('email change error', error)
      })

    return () => {
      active = false
    }
  }, [token])

  if (state === 'loading') {
    return <DefaultLoading />
  }

  const message = {
    success: t('メールアドレス変更が完了しました。'),
    unauthorized: t(
      'ログイン状態を確認できませんでした。変更を申請したアカウントでログインした状態で、メールのURLを再度開いてください。'
    ),
    expired: t('メールアドレス変更用URLの有効期限が切れているか、既に使用されています。'),
    conflict: t(
      'このメールアドレスは既に使用されているため変更できません。別のメールアドレスで再度お手続きください。'
    ),
    error: t('メールアドレス変更に失敗しました。しばらく時間をおいて、もう一度お試しください。'),
  }[state]

  return (
    <Container innerWidth={'800px'}>
      <Title text={t('メールアドレス変更')} />
      <div className={'mt24'}>
        {message}
        {state === 'success' && (
          <>
            <br />
            {t('トップページからログインしてください。')}
          </>
        )}
      </div>
      <div className={'mt24'}>
        <Center className={'mt8'}>
          <TextLink text={t('トップページへ戻る')} to={'/login'} />
        </Center>
      </div>
    </Container>
  )
}

export default EmailChangeComplete
